// Product page, phones: sticky buy bar from page load and a clear area for the SalesDrive chat button.
// Markup: snippets/blush-sticky-atc.liquid; styles: blush-cro-pdp.css, blush-cro-pdp-chat.css.
// Everything is driven by IntersectionObserver and MutationObserver: no scroll or tap handlers.
(function () {
  var phone = window.matchMedia('(max-width: 749px)');
  var body = document.body;

  // This file runs again when Dawn re-injects the section (quick add, product swap).
  // Only a bar that is not inside a quick-add modal and not yet set up starts a new instance.
  var bar = Array.prototype.filter.call(document.querySelectorAll('[data-blush-cro-sticky]'), function (el) {
    return !el.hasAttribute('data-ready') && !el.closest('.quick-add-modal');
  })[0];
  if (!bar) return;

  var form = document.getElementById(bar.dataset.formId);
  var mainButton = form && form.querySelector('[name="add"]');
  if (!mainButton || !('IntersectionObserver' in window)) return;

  if (window.blushCroPdp) window.blushCroPdp.destroy();

  bar.setAttribute('data-ready', '');
  body.appendChild(bar); // escape transformed ancestors so position: fixed works

  var info = form.closest('product-info') || document;
  var buyBox = mainButton.closest('.product-form__buttons') || mainButton;
  var priceBox = info.querySelector('[id^="price-"]');
  var priceTarget = bar.querySelector('[data-blush-sticky-price]');
  var stickyButton = bar.querySelector('[data-blush-sticky-add]');
  var addText = (window.variantStrings && window.variantStrings.addToCart) || '';

  var mode = 'add'; // add | loading | notify | off
  var target = mainButton;
  var mainInView = true; // until the observer reports, so the bar does not flash in
  var shown = false;
  var observers = [];
  var timer;

  function label(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function render() {
    var on = phone.matches && mode !== 'off';
    var show = on && !mainInView;
    body.classList.toggle('blush-cro-sticky-ready', on);
    if (show === shown) return;
    shown = show;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    stickyButton.tabIndex = show ? 0 : -1;
  }

  // Mirror the main form: add to cart, the back-in-stock button of the preorder app, or nothing.
  function sync() {
    var mainLabel = label(mainButton);
    var notify = null;
    if (!mainButton.disabled) {
      mode = 'add';
    } else if (addText && mainLabel === addText) {
      mode = 'loading'; // product-info.js disables the button while a variant is loading
    } else {
      notify = form.querySelector('[data-essential-preorder-element="back-in-stock-button"]');
      mode = notify && notify.getClientRects().length ? 'notify' : 'off';
    }

    if (mode === 'add') {
      target = mainButton;
      stickyButton.textContent = mainLabel && mainLabel !== addText ? mainLabel : bar.dataset.addLabel;
    } else if (mode === 'notify') {
      target = notify;
      stickyButton.textContent = label(notify);
    }
    stickyButton.disabled = mode === 'loading' || mode === 'off';

    var price = info.querySelector('.product__price-mobile-main') || info.querySelector('.price-item--last');
    if (price && label(price)) priceTarget.textContent = label(price);
    render();
  }

  function queueSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 120);
  }

  stickyButton.addEventListener('click', function () {
    if (mode === 'add' || mode === 'notify') target.click();
  });

  var watch = new MutationObserver(queueSync);
  watch.observe(buyBox, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
  if (priceBox) watch.observe(priceBox, { subtree: true, childList: true, characterData: true });
  observers.push(watch);

  // The bar is shown unless the buy buttons are fully on screen (a half-visible button at the bottom
  // edge goes under the bar, which then offers the same action).
  var buyObserver = new IntersectionObserver(function (entries) {
    var entry = entries[entries.length - 1];
    mainInView = entry.isIntersecting && entry.intersectionRatio >= 0.98;
    render();
  }, { threshold: [0, 0.98, 1] });
  buyObserver.observe(buyBox);
  observers.push(buyObserver);

  // The chat button sits in the bottom quarter of the screen: hide it while the variant pills
  // or the buy buttons pass through that band, so it never covers them.
  var crossing = [];
  var chatObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var i = crossing.indexOf(entry.target);
      if (entry.isIntersecting && i === -1) crossing.push(entry.target);
      if (!entry.isIntersecting && i !== -1) crossing.splice(i, 1);
    });
    body.classList.toggle('blush-cro-chat-clear', crossing.length > 0);
  }, { rootMargin: '-72% 0px 0px 0px' });
  [info.querySelector('variant-selects'), buyBox].forEach(function (el) {
    if (el) chatObserver.observe(el);
  });
  observers.push(chatObserver);

  function measure() {
    if (phone.matches && bar.offsetHeight) {
      document.documentElement.style.setProperty('--blush-cro-sticky-h', bar.offsetHeight + 'px');
    }
    render();
  }
  if (phone.addEventListener) phone.addEventListener('change', measure);
  else if (phone.addListener) phone.addListener(measure);

  window.blushCroPdp = {
    destroy: function () {
      observers.forEach(function (o) { o.disconnect(); });
      clearTimeout(timer);
      if (phone.removeEventListener) phone.removeEventListener('change', measure);
      else if (phone.removeListener) phone.removeListener(measure);
      body.classList.remove('blush-cro-sticky-ready', 'blush-cro-chat-clear');
      bar.remove();
      window.blushCroPdp = null;
    },
  };

  measure();
  sync();
})();
